import classNames from 'classnames';

import { useDocumentShareUrlGenerator } from '../../hooks/useUrlGenerator';

import ShareUrlField from '../fields/ShareUrlField';
import DocumentFeaturedCard, { DocumentFeaturedCardProps } from './DocumentFeaturedCard';

import styles from '../../styles/cards/document-share-card.module.css';

function DocumentShareCard({
    className = null,
    withBorderRadius = true,
    ...props
}: DocumentFeaturedCardProps) {
    const shareUrl = useDocumentShareUrlGenerator();
    const url = shareUrl(props);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withBorderRadius]: withBorderRadius,
                },
                className,
            ])}
        >
            <DocumentFeaturedCard
                withUrbaniaLogo
                withoutAuthorBox
                withoutAuthorImage
                withoutSponsor
                withoutDate
                withBorderRadius={withBorderRadius}
                theme="over-bottom-left"
                imageSize="large"
                ratio="vertical"
                {...props}
                className={styles.card}
            />
            <ShareUrlField value={url} className={styles.field} />
        </div>
    );
}

export default DocumentShareCard;
